import { HTTP } from '../../shared/http-common';
import axios from 'axios';

export default {
  name: 'ChangePassword',
  data() {
    return {
      uuid: this.$route.query.uuid,
      code: this.$route.query.code,
      newPassword: null,
      newPassword2: null,
      passwordChangeStatusMessage: null,
      passwordChangeStatusSuccess: false,
      isBusy: false,
      validationResultsError: null,
      passwordSettings: {
        // Minimal password length
        minimalLength: 8,
        // Maximal password length
        maximalLength: 264,
        // Minimum amount of digits [0-9] required
        needNumber: 0,
        // Minimum amount of non-alphanumeric characters required
        needNonAlphanumeric: 0,
        // Minimum amount of uppercase characters required
        needUppercase: 1,
        // Minimum amount of lowercase characters required
        needLowercase: 0
      }
    }

  },
  computed: {
    invalidPassword: function () {
      if (this.newPassword != null) {
       //return this.newPassword.length < 6 || this.newPassword.length > 17;
        return !this.passwordIsValid(this.newPassword, this.passwordSettings)
       }
      return false;
    },
    passwordsDontMatch: function () {
      if (this.newPassword2 != null && this.newPassword != null) {
        return this.newPassword2 !== this.newPassword;
      }
      return false;
    },


  },
  methods: {

    /**
     *
     * @param c
     * @returns {boolean}
     */
    charIsDigit: function(c) {
      return(c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0));
    },

    charIsLetter: function(c) {
      return c.length === 1 && c.match(/[a-z]/i);
    },

    charIsUpperCase: function(c) {
      return c == c.toUpperCase();
    },

    charIsLowerCase: function(c) {
      return c == c.toLowerCase();
    },

    changePassword(e) {
      if (!this.invalidPassword && !this.invalidOrderId) {
        this.changePasswordRequest(process.env.BASE_URL + process.env.USER_CHANGE_PASSWORD_ENDPOINT + '/' + this.uuid);
      }
    },

    /**
     * Change password
     * @param {*} url
     *
     */
    changePasswordRequest(url) {
      this.isBusy = true;
      HTTP.post(url, {
        "type" : "reset",
        "password" : this.newPassword,
        "code" : this.code
      })
        .then(response => {
        this.isBusy = false;
      //var requestStatus = response.data.status;

      if (response.status !== 200) {
        this.displayPasswordChangeStatus(false, response.data)
      } else {
        this.displayPasswordChangeStatus(true)
        this.newPassword = null;
        this.newPassword2 = null;
      }
      this.isBusy = false;
    })
    .catch(error => {
        this.displayPasswordChangeStatus(false, error.response.data);
      this.isBusy = false;
    });
    },


    /**
     *
     * @param success
     * @param errorMessageData
     */

    displayPasswordChangeStatus(success, errorMessageData) {
      this.passwordChangeStatusSuccess = success;
      var message = success ? "Password successfully changed" : "There was an error changing the password. Reason: "
      this.passwordChangeStatusMessage = (errorMessageData ? message + errorMessageData.message : message) + ". ";
      if (errorMessageData.hasOwnProperty('details') && errorMessageData.details.length > 0) {
        this.passwordChangeStatusMessage += errorMessageData.details[0].message;
      }
    },

    /**
     *
     * @param password
     * @param {object} ruleSetProperties
     */
    passwordIsValid(password, ruleSetProperties) {

      var minLength = ruleSetProperties.minimalLength;
      var maxLength = ruleSetProperties.maximalLength;
      var needNumber = ruleSetProperties.needNumber;
      var needNonAlphanumeric = ruleSetProperties.needNonAlphanumeric;
      var needUppercase = ruleSetProperties.needUppercase;
      var needLowercase = ruleSetProperties.needLowercase;

      var length = password.length;
      var countDigits = 0;
      var countNonAlphanumeric = 0;
      var countUppercase = 0;
      var countLowercase = 0;
      var validationResults = new Array();

      for (var i = 0; i < length; i++) {
        var ch = password.charAt(i);
        if (this.charIsDigit(ch)) {
          countDigits++;
          continue;
        }
        if (this.charIsLetter(ch)) {
          if (this.charIsUpperCase(ch)) {
            countUppercase++;
            continue;
          }
          if (this.charIsLowerCase(ch)) {
            countLowercase++;
            continue;
          }
        }
        countNonAlphanumeric++;
      }

      if (minLength > length) {
        validationResults.push("Password requires a minimal length of " + minLength + " characters");
      }
      if (maxLength < length) {
        validationResults.push("Password contains too many characters. A maximum of " + maxLength + " characters is allowed");
      }
      if (countDigits < needNumber) {
        validationResults.push("Password requires at least " + needNumber + " digits");
      }
      if (countUppercase < needUppercase) {
        validationResults.push("Password requires at least " + needUppercase + " uppercase characters");
      }
      if (countLowercase < needLowercase) {
        validationResults.push("Password requires at least " + needLowercase + " lowercase characters");
      }
      if (countNonAlphanumeric < needNonAlphanumeric) {
        validationResults.push("Password requires at least " + needNonAlphanumeric + " non alphanumeric characters");
      }

      if (validationResults.length > 0) {
        this.validationResultsError = validationResults.join("\n");
      }
      console.log(validationResults.length === 0);
      return validationResults.length === 0;
    }

  }
}



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js